const findOneColumnParentContainer = (...classNames) => {
	// Finds and returns the one column parent container for an element given an array of querySelector values
	let container;
	const commaSeperatedClassNames = classNames.join(",");
	/* 
	querySelector can handle || with commas: <element class="foo bar"/> can be 
	queried with foo or bar: querySelector(.foo,.bar)
	*/
	document
		.querySelectorAll(".one-column-parent-container")
		.forEach((element) =>
			element.querySelector(commaSeperatedClassNames) ? (container = element) : null
		);
	const containerCSS = getComputedStyle(container);
	// return an object with the one column parent container and the associated css
	return { container, containerCSS };
};

export default findOneColumnParentContainer;
